export const MKT_METRICAS_DESIGN = {
  page: {
    container: 'container mx-auto px-4 py-4 h-full flex flex-col overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-500',
    scrollArea: 'flex-1 overflow-y-auto min-h-0 pb-20 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent pr-2'
  },
  header: {
    wrapper: 'flex-none mb-6 bg-white rounded-xl border border-gray-100 shadow-sm p-4',
    topRow: 'flex items-center justify-between gap-4 flex-wrap',
    left: 'flex items-center gap-3 min-w-0',
    backBtn: 'h-9 w-9 rounded-lg hover:bg-gray-100 flex-shrink-0',
    iconBox: 'w-11 h-11 rounded-2xl flex items-center justify-center bg-violet-100 flex-shrink-0',
    icon: 'text-violet-600',
    title: 'text-lg font-bold text-gray-900 truncate',
    subtitle: 'text-xs text-gray-500',
    badgeRow: 'flex items-center gap-2 flex-shrink-0 flex-wrap',
    metaRow: 'flex flex-wrap items-center gap-6 mt-4 pt-4 border-t border-gray-100',
    metaItem: 'flex items-center gap-2.5',
    metaIconBox: 'w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center flex-shrink-0',
    metaLabel: 'text-xs font-semibold text-gray-400 uppercase tracking-wider',
    metaValue: 'text-sm font-semibold text-gray-900',
    keywordsWrap: 'flex flex-wrap items-center gap-1.5 mt-3 pt-3 border-t border-gray-100',
    keywordsLabel: 'text-xs font-semibold text-gray-400 uppercase tracking-wider mr-1',
    keywordChip: 'px-2.5 py-1 rounded-full text-xs font-medium bg-violet-50 text-violet-700 border border-violet-100 whitespace-nowrap',
    keywordChipMore: 'px-2.5 py-1 rounded-full text-xs font-medium bg-gray-50 text-gray-500 border border-gray-200 whitespace-nowrap'
  },
  statusBadge: {
    ativa: 'text-xs font-medium flex items-center gap-1.5 bg-green-50 text-green-700 border border-green-200 px-2.5 py-1 rounded-full',
    pausada: 'text-xs font-medium flex items-center gap-1.5 bg-amber-50 text-amber-700 border border-amber-200 px-2.5 py-1 rounded-full',
    finalizada: 'text-xs font-medium flex items-center gap-1.5 bg-gray-100 text-gray-700 border border-gray-200 px-2.5 py-1 rounded-full',
    erro: 'text-xs font-medium flex items-center gap-1.5 bg-red-50 text-red-700 border border-red-200 px-2.5 py-1 rounded-full'
  },
  platformBadge: {
    facebook: { label: 'Facebook Ads', icon: 'mdi:facebook', className: 'text-xs font-medium flex items-center gap-1.5 bg-blue-50 text-[#1877F2] border border-blue-100 px-2.5 py-1 rounded-full' },
    google: { label: 'Google Ads', icon: 'mdi:google-ads', className: 'text-xs font-medium flex items-center gap-1.5 bg-amber-50 text-amber-700 border border-amber-200 px-2.5 py-1 rounded-full' },
    instagram: { label: 'Instagram Ads', icon: 'mdi:instagram', className: 'text-xs font-medium flex items-center gap-1.5 bg-pink-50 text-pink-700 border border-pink-200 px-2.5 py-1 rounded-full' }
  },
  section: {
    wrapper: 'bg-white rounded-xl border border-gray-100 shadow-sm p-6 mb-6',
    headerRow: 'flex items-center justify-between mb-6 flex-wrap gap-3',
    title: 'text-lg font-bold text-gray-900 flex items-center gap-3',
    titleIconBox: 'p-2 rounded-lg'
  },
  stats: {
    grid: 'grid grid-cols-2 gap-4'
  },
  table: {
    card: 'border-0 bg-white shadow-sm rounded-xl',
    headCell: 'text-gray-600 font-semibold sticky top-0 z-10 bg-white',
    row: 'hover:bg-gray-50 transition-colors',
    progressTrack: 'w-20 bg-gray-100 rounded-full h-2.5 overflow-hidden',
    progressFill: 'h-full rounded-full transition-all duration-500'
  },
  crm: {
    wrapper: 'mb-6 bg-white rounded-xl border border-gray-100 shadow-sm p-4'
  },
  chatsTable: {
    wrapper: 'bg-white rounded-xl border border-gray-100 shadow-sm p-6 mb-8'
  },
  exportBtn: 'flex items-center gap-2'
};
